module.exports = __webpack_public_path__ + "assets/images/company-logo-8f6f7c3b303004256295b45c2eee5117.png";